import { Component, OnInit } from "@angular/core";
import {
  Validators,
  FormGroup,
  FormControl,
  ValidatorFn,
} from "@angular/forms";
import { Location } from "@angular/common";
import { MessageService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { FechasService } from "src/app/services/fechas/fechas";
import { GenericService } from "../../../services/generic/generic.service";
import { siEsNull } from "src/app/config/texto_comprobacion";
import { url } from "src/app/config/config";
import { UploadService } from "src/app/services/upload/upload.service";
import { Utils } from "src/app/common/utils";
import { handleImageUpload } from "src/app/config/compress_image";
import { Role } from "src/app/common/role";

interface FieldsForm {
  nombre: string;
  label: string;
  type: string;
  col: number;
  validation: ValidatorFn[];
  adminOnly?: boolean;
  defaultValue?: any;
  show?: boolean;
}

@Component({
  selector: "app-articulos-create",
  templateUrl: "./articulos-create.component.html",
  styleUrls: ["./articulos-create.component.css"],
})
export class ArticulosCreateComponent implements OnInit {
  public fileName = "imagen.jpg";
  public numberPhoto = 1;
  public showCamera = false;
  public es = Utils.es;
  public identifierImage: any;
  public urlDeafaultImage: any;

  campos: FieldsForm[] = [
    {
      nombre: "id_proveedor",
      label: "Proveedor",
      type: "generic-dropdown",
      col: 4,
      validation: [Validators.required],
      adminOnly: true,
    },
    {
      nombre: "nombre",
      label: "Nombre",
      type: "text",
      col: 4,
      validation: [Validators.required],
    },
    {
      nombre: "descripcion",
      label: "Descripción",
      type: "textarea",
      col: 4,
      validation: [],
    },
    { nombre: "color", label: "Color", type: "text", col: 3, validation: [] },
    {
      nombre: "maceta",
      label: "Maceta (CM / Litros)",
      type: "text",
      col: 3,
      validation: [],
    },
    {
      nombre: "tamano",
      label: "Tamaño (Altura / calibre)",
      type: "text",
      col: 3,
      validation: [],
    },
    {
      nombre: "peso",
      label: "Peso (Kg)",
      type: "number",
      col: 3,
      validation: [],
    },
    {
      nombre: "unidades_caja",
      label: "Unidades/caja",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "unidades_piso",
      label: "Unidades/piso",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "unidades_cc",
      label: "Unidades/cc",
      type: "number",
      col: 4,
      validation: [Validators.required],
    },
    {
      nombre: "pisos_cc",
      label: "Pisos/cc",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "ean_vivero",
      label: "EAN vivero",
      type: "text",
      col: 4,
      validation: [],
    },
    {
      nombre: "fecha_creacion",
      label: "Fecha creación",
      type: "date",
      col: 4,
      validation: [],
    },
    {
      nombre: "precio_neto_vivero",
      label: "Precio neto vivero",
      type: "number",
      col: 4,
      validation: [Validators.required],
    },
    {
      nombre: "precio_etiqueta_articulo",
      label: "Precio etiquetado por artículo",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "cantidad_disponible",
      label: "Cantidad disponible",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "cantidad_reservada",
      label: "Cantidad reservada",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "cantidad_cargada",
      label: "Cantidad cargada",
      type: "number",
      col: 4,
      validation: [],
    },
    {
      nombre: "activo",
      label: "Activo",
      type: "switch",
      col: 4,
      validation: [],
    },
    {
      nombre: "precio_comision_articulo",
      label: "Precio comisión por artículo",
      type: "number",
      col: 4,
      defaultValue: 10,
      validation: [],
    },
    {
      nombre: "precio_comision_carro",
      label: "Precio comisión por carro mix",
      type: "number",
      col: 4,
      validation: [],
      defaultValue: 20,
      adminOnly: true,
    },
    {
      nombre: "codigo_generico",
      label: "Código Genérico",
      type: "text",
      col: 4,
      validation: [],
    },
    {
      nombre: "codigo_dehner",
      label: "Código Dehner",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
    {
      nombre: "codigo_schmid",
      label: "Código Schmid",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
    {
      nombre: "codigo_migros",
      label: "Código Transportgemeinschaft",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
    {
      nombre: "codigo_irsslinger",
      label: "Código Irsslinger",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
    {
      nombre: "codigo_blume2000",
      label: "Código Blume2000",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
    {
      nombre: "codigo_landgard",
      label: "Código Landgard",
      type: "text",
      col: 4,
      validation: [],
      adminOnly: true,
    },
  ];

  form = new FormGroup({});

  public database = "articulos";
  public update = false;
  public id = "";
  public noGrabar = false;
  public dateUpdate = new Date();

  public file: File;
  public file2: File;
  public file3: File;
  public file4: File;
  public file5: File;
  public imagePath;
  public message: string;
  public img: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public imgURL: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public imgURL2: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public imgURL3: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public imgURL4: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public imgURL5: any =
    "https://static.vecteezy.com/system/resources/previews/022/014/063/large_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
  public url: string = url + "upload/articulos/";

  isAdmin = new Role().checkRole();

  constructor(
    private location: Location,
    private messageService: MessageService,
    private genericService: GenericService,
    private _fechaService: FechasService,
    private router: Router,
    private route: ActivatedRoute,
    private _uploadService: UploadService,
  ) {
    this.form = new FormGroup({});
    this.campos.forEach((campo) => {
      this.form.addControl(
        campo.nombre,
        new FormControl(campo.defaultValue ?? "", campo.validation || []),
      );
    });
    ["archivo1", "archivo2", "archivo3", "archivo4", "archivo5"].forEach(
      (name) => {
        this.form.addControl(name, new FormControl(""));
      },
    );
  }

  ngOnInit(): void {
    this.route.params.subscribe((data) => {
      if (data.id == undefined) {
        this.iniciar(null);
      } else {
        this.id = data.id;
        this.update = true;
        this.genericService
          .getId(this.id, this.database)
          .toPromise()
          .then((resp: any) => {
            this.iniciar(resp[0] ?? null);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    });
  }

  iniciar(value) {
    let articulo = value;

    if (articulo != null) {
      for (const key in articulo) {

        const control = this.form.get(key);

        if (control) {
          if (key.localeCompare("id") == 0) {
          } else {
            if (key.includes("fecha")) {
              control.patchValue(this._fechaService.fechaUpdate(articulo[key]));
            } else if (key.includes("activo")) {
              control.patchValue(
                articulo[key] == "1" || articulo[key] == 1 ? true : false,
                );
            } else {
              control.patchValue(siEsNull(articulo[key]));
            }
          }

          if (key.includes("archivo") && articulo[key] != null && articulo[key] != "") {
            let urlImage = this.url + articulo[key];
            switch (key) {
              case "archivo1":
                this.imgURL = urlImage;
                this.urlDeafaultImage = urlImage;
                break;
              case "archivo2":
                this.imgURL2 = urlImage;
                break;
              case "archivo3":
                this.imgURL3 = urlImage;
                break;
              case "archivo4":
                this.imgURL4 = urlImage;
                break;
              case "archivo5":
                this.imgURL5 = urlImage;
                break;
              default:
            }
          }
        }
      }

      // if (
      //   this.form.get("archivo1").value &&
      //   this.form.get("archivo1").value.length > 0
      // ) {
      //   this.imgURL = this.url + this.form.get("archivo1").value;
      //   this.urlDeafaultImage = this.imgURL;
      // } else {
      //   this.imgURL = false;
      // }
      // if (
      //   this.form.get("archivo2").value != null &&
      //   this.form.get("archivo2").value.length > 0
      // ) {
      //   this.imgURL2 = this.url + this.form.get("archivo2").value;
      // } else {
      //   this.imgURL2 = false;
      // }
      // if (
      //   this.form.get("archivo3").value != null &&
      //   this.form.get("archivo3").value.length > 0
      // ) {
      //   this.imgURL3 = this.url + this.form.get("archivo3").value;
      // } else {
      //   this.imgURL3 = false;
      // }
      // if (
      //   this.form.get("archivo4").value != null &&
      //   this.form.get("archivo4").value.length > 0
      // ) {
      //   this.imgURL4 = this.url + this.form.get("archivo4").value;
      // } else {
      //   this.imgURL4 = false;
      // }
      // if (
      //   this.form.get("archivo5").value != null &&
      //   this.form.get("archivo5").value.length > 0
      // ) {
      //   this.imgURL5 = this.url + this.form.get("archivo5").value;
      // } else {
      //   this.imgURL5 = false;
      // }
    }
  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.noGrabar = true;
    let data = [{}];
    data[0]["id"] = this.id || "0";

    for (const key in this.form.value) {
      data[0][key] = this.form.value[key];
    }

    data[0]["fecha_creacion"] = this._fechaService.arreglarFecha(
      this.form.get("fecha_creacion").value,
    );



    // Condicion cuando se edita el registro

    if (this.update) {
      let today = this._fechaService.currentDate();
      data[0]["fecha_creacion"] = today;

      this.genericService
        .update(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          if (this.file != null) {
            this.fileUpload(this.file, this.id, "archivo1");
          }
          if (this.file2 != null) {
            this.fileUpload(this.file2, this.id, "archivo2");
          }
          if (this.file3 != null) {
            this.fileUpload(this.file3, this.id, "archivo3");
          }
          if (this.file4 != null) {
            this.fileUpload(this.file4, this.id, "archivo4");
          }
          if (this.file5 != null) {
            this.fileUpload(this.file5, this.id, "archivo5");
          }

          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro actualizado correctamente",
          });

          setTimeout(() => {
            if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
              this.router.navigate(["/dashboard/articulos"]);
            } else {
              this.router.navigate(["/dashboard/articulos_proveedor"]);
            }
          }, 2000);
        })
        .catch((error) => {
          console.log("error artículos", error);
        });
    } else {
      // Condicion cuando se crea un nuevo registro

      this.genericService
        .create(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          data[0]["id"] = resp.id;
          this.id = resp.id;
          this.genericService.update(data[0], this.database).toPromise();

          if (this.file != null) {
            this.fileUpload(this.file, this.id, "archivo1");
          }
          if (this.file2 != null) {
            this.fileUpload(this.file2, this.id, "archivo2");
          }
          if (this.file3 != null) {
            this.fileUpload(this.file3, this.id, "archivo3");
          }
          if (this.file4 != null) {
            this.fileUpload(this.file4, this.id, "archivo4");
          }
          if (this.file4 != null) {
            this.fileUpload(this.file4, this.id, "archivo4");
          }
          if (this.file5 != null) {
            this.fileUpload(this.file5, this.id, "archivo5");
          }

          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro creado correctamente",
          });

          setTimeout(() => {
            if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
              this.router.navigate(["/dashboard/articulos"]);
            } else {
              this.router.navigate(["/dashboard/articulos_proveedor"]);
            }
          }, 2000);
        })
        .catch((error) => {
          console.log("Error Articulos, error");
        });
    }
  }

  fileUpload(file: File, id: string, name: string) {
    this._uploadService
      .uploadFilesgeneric(file, id, "articulos", "articulos", name)
      .subscribe(
        (res) => {
          this.messageService.add({
            severity: "info",
            summary: "Registro imagen",
            detail: "Imagen Añadida Correctamente",
          });
          setTimeout(
            function () {
              // this.router.navigate(["dashboard/etiquetas"]);
              this.disableButton = false;
            }.bind(this),
            2000,
          );
        },
        (error) => {
          console.error("Error", error);
        },
      );
  }

  async uploadFile(event, position: number) {
    if (position == 1) {
      this.file = await this.newPicture(event);
    }
    if (position == 2) {
      this.file2 = await this.newPicture(event);
    }
    if (position == 3) {
      this.file3 = await this.newPicture(event);
    }
    if (position == 4) {
      this.file4 = await this.newPicture(event);
    }
    if (position == 5) {
      this.file5 = await this.newPicture(event);
    }
    let files = event.target.files;
    /*     let numb = this.file.name.lastIndexOf("."); */
    if (files.length === 0) return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      if (position == 1) {
        this.imgURL = reader.result;
      }
      if (position == 2) {
        this.imgURL2 = reader.result;
      }
      if (position == 3) {
        this.imgURL3 = reader.result;
      }
      if (position == 4) {
        this.imgURL4 = reader.result;
      }
      if (position == 5) {
        this.imgURL5 = reader.result;
      }
    };
  }

  async newPicture(event) {
    let file: any = [];

    file = null;
    file = await handleImageUpload(event);
    return file;
  }

  setProveedor(event) {
    this.form.patchValue({
      id_proveedor: event,
    });
  }

  deleteImagen(numero: number) {
    const slotMap = {
      1: { fileKey: "file", imgKey: "imgURL", formKey: "archivo1" },
      2: { fileKey: "file2", imgKey: "imgURL2", formKey: "archivo2" },
      3: { fileKey: "file3", imgKey: "imgURL3", formKey: "archivo3" },
      4: { fileKey: "file4", imgKey: "imgURL4", formKey: "archivo4" },
      5: { fileKey: "file5", imgKey: "imgURL5", formKey: "archivo5" },
    };

    const selected = slotMap[numero];

    if (!selected) {
      return;
    }

    this[selected.fileKey] = null;
    this[selected.imgKey] = this.img;
    this.form.get(selected.formKey)?.patchValue("");

    if (this.urlDeafaultImage === this[selected.imgKey]) {
      this.identifierImage = "archivo1";
      this.urlDeafaultImage = this.imgURL;
    }
  }

  getImage(event: { base64: string; file: File; numero: number }) {
    if (event.numero == 1) {
      this.imgURL = event.base64;
      this.file = event.file;
    }
    if (event.numero == 2) {
      this.imgURL2 = event.base64;
      this.file2 = event.file;
    }
    if (event.numero == 3) {
      this.imgURL3 = event.base64;
      this.file3 = event.file;
    }
    if (event.numero == 4) {
      this.imgURL4 = event.base64;
      this.file4 = event.file;
    }
    this.showCamera = false;
  }

  openCamera(numero: number) {
    this.fileName = "imagen" + numero.toString() + ".jpg";
    this.numberPhoto = numero;
    this.showCamera = true;
  }

  closeDialog(event) {
    this.showCamera = false;
  }

  private swapImageSlots(selectedSlot: string) {
    if (!selectedSlot || selectedSlot === "archivo1") {
      this.identifierImage = "archivo1";
      this.urlDeafaultImage = this.imgURL;
      return;
    }

    const slotMap = {
      archivo1: { fileKey: "file", imgKey: "imgURL", formKey: "archivo1" },
      archivo2: { fileKey: "file2", imgKey: "imgURL2", formKey: "archivo2" },
      archivo3: { fileKey: "file3", imgKey: "imgURL3", formKey: "archivo3" },
      archivo4: { fileKey: "file4", imgKey: "imgURL4", formKey: "archivo4" },
      archivo5: { fileKey: "file5", imgKey: "imgURL5", formKey: "archivo5" },
    };

    const selected = slotMap[selectedSlot];
    const first = slotMap["archivo1"];

    if (!selected) {
      return;
    }

    const firstFile = this[first.fileKey];
    const firstImg = this[first.imgKey];
    const firstFormValue = this.form.get(first.formKey)?.value;

    this[first.fileKey] = this[selected.fileKey];
    this[first.imgKey] = this[selected.imgKey];
    this.form.get(first.formKey)?.patchValue(this.form.get(selected.formKey)?.value ?? "");

    this[selected.fileKey] = firstFile;
    this[selected.imgKey] = firstImg;
    this.form.get(selected.formKey)?.patchValue(firstFormValue ?? "");

    this.identifierImage = "archivo1";
    this.urlDeafaultImage = this.imgURL;
  }

  async defaultImage(event, data) {
    let aux = await event.target;
    const selectedSlot = aux.id;

    this.swapImageSlots(selectedSlot);
    this.identifierImage = "archivo1";
    this.urlDeafaultImage = this.imgURL;
  }
}
